import { Pipe, PipeTransform } from '@angular/core';
import { environment } from 'src/environments/environment';
import { APP_ENV } from '../conf/app_env'
import { GlobalService } from '../services/global.service';

@Pipe({
    name: 'env',
    standalone: false
})
export class EnvPipe implements PipeTransform {

	constructor(private _gS: GlobalService) { }

	/** Using pipe in case in future becomes more complex enviroment conditions */
	transform(env: APP_ENV): boolean {
		return environment.appEnv == env;
	}

}
